var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVatCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0402 6.82087L12.0403 6.82092L12.0462 6.81483C12.4236 6.42438 12.4321 5.79894 12.0402 5.4071C11.6516 5.0185 11.015 5.0185 10.6264 5.4071L7.55333 8.48021L6.37355 7.30043C5.98496 6.91184 5.34838 6.91184 4.95978 7.30043C4.57119 7.68903 4.57118 8.32561 4.95978 8.7142L6.84645 10.6009L7.2 10.2473L6.84645 10.6009C7.03248 10.7869 7.28589 10.894 7.55333 10.894C7.82078 10.894 8.07419 10.7869 8.26022 10.6009L12.0402 6.82087ZM2.33333 8.00065C2.33333 4.60346 5.10281 1.83398 8.5 1.83398C11.8972 1.83398 14.6667 4.60346 14.6667 8.00065C14.6667 11.3978 11.8972 14.1673 8.5 14.1673C5.10281 14.1673 2.33333 11.3978 2.33333 8.00065Z",
    fill: "#39B44A",
    stroke: "#39B44A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVatCircle);
export default __webpack_public_path__ + "static/media/vat-circle.af1cc720500978a3b65eb37bf8e70846.svg";
export { ForwardRef as ReactComponent };